import _classCallCheck from '@babel/runtime/helpers/classCallCheck';
import _createClass from '@babel/runtime/helpers/createClass';
import _defineProperty from '@babel/runtime/helpers/defineProperty';
import { replace, omit } from 'lodash-es';

/**
 * Path
 *
 * Auto-replaces parameters in the path, e.g. `/path/with/{param}`, with the
 * given arguments.
 */
var ArgumentPath = /*#__PURE__*/function () {
  function ArgumentPath(_ref) {
    var _this = this;
    var _path = _ref.path,
      _args = _ref.args,
      _ref$isLocal = _ref.isLocal,
      isLocal = _ref$isLocal === void 0 ? true : _ref$isLocal;
    _classCallCheck(this, ArgumentPath);
    // Raw, unprocessed path
    _defineProperty(this, "raw", '');
    // Arguments
    _defineProperty(this, "args", {});
    // The regular expression for parameters in path, e.g. `/path/with/{param}`.
    _defineProperty(this, "PARAM_REGEX", /{.*?}/g);
    /**
     * Replaces parameters in a path with the given argument, e.g. `/property/{id}` becomes `/property/123-456-789`.
     * Parameters are considered required. If the parameter was not given, an error is thrown.
     * @param {string} path
     * @param {object} args
     */
    _defineProperty(this, "replaceParametersWith", function (path, args) {
      return replace(path, _this.PARAM_REGEX, function (foundParameter) {
        var parameterName = foundParameter.replace('{', '').replace('}', '');
        return args[parameterName];
      });
    });
    /**
     * Gets all parameter names from a path - as an array
     * @param {string} path
     * @returns [string]
     */
    _defineProperty(this, "getParametersFromPath", function (path) {
      return path.match(_this.PARAM_REGEX).map(function (foundParameter) {
        return foundParameter.replace('{', '').replace('}', '');
      });
    });
    /**
     * Removes the parameters used in the path from the args object
     * @param {string} path
     * @param {object} args
     * @returns {object}
     */
    _defineProperty(this, "removeParametersFromArgs", function (path, args) {
      return omit(args, _this.getParametersFromPath(path));
    });
    if (typeof _path !== 'string' || !_path.length) {
      throw new Error('Given path is empty or not a string.');
    }
    this.raw = _path;
    this.args = _args;
    this.isLocal = isLocal;

    // Check for errors & warn about them locally
    if (this.hasParameters && isLocal) {
      this.allParameters.forEach(function (parameterName) {
        if (!_args[parameterName]) {
          console.warn("The path \"".concat(_path, "\" has a parameter in it, but it can't be replaced because \"").concat(parameterName, "\" is not in the arguments."));
        }
        if (!(typeof _args[parameterName] === 'string' || typeof _args[parameterName] === 'number')) {
          console.warn("The path \"".concat(_path, "\" has a parameter in it, but the argument \"").concat(parameterName, "\" is not a string or a number."));
        }
      });
    }
  }

  // Returns true if the path contains replaceable parameters
  return _createClass(ArgumentPath, [{
    key: "hasParameters",
    get: function get() {
      return !!this.raw.match(this.PARAM_REGEX);
    }

    // All parameters as an array
  }, {
    key: "allParameters",
    get: function get() {
      return this.getParametersFromPath(this.raw);
    }

    // Returns the processed path with the given arguments
  }, {
    key: "processed",
    get: function get() {
      return this.replaceParametersWith(this.raw, this.args);
    }

    // Arguments without parameters
  }, {
    key: "argsWithoutParameters",
    get: function get() {
      return this.removeParametersFromArgs(this.raw, this.args);
    }
  }]);
}();
export { ArgumentPath as default };